import React, {Component} from 'react';
import styled from 'styled-components';
import {mixins} from "../../mixins";

const Label = styled.div`
  text-transform: uppercase;
  font-weight: 900;
  color: ${p => p.active ? p.theme.cTheme : ''};
  ${mixins.ease()};
`;

const ToggleBody = styled.div`
  height: 26px;
  width: 53px;
  margin: 0 10px;
  border: 1px solid ${p => p.theme.cMicrocopyText};
  padding: 2px;
`;

const ToggleWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  
`;

const Handle = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: ${p => p.theme.cTheme};
  left: ${p => p.flipped ? '26px' : 0};
  ${mixins.ease()};
`;

class Toggle extends Component {
    constructor(props) {
        super(props);

        this.handleCallback = this.handleCallback.bind(this);
    }

    handleCallback(){
        if(typeof(this.props.callback) === 'function'){
            this.props.callback();
        }
    }

    render() {
        return (
            <div role={'button'} onClick={this.handleCallback} className={this.props.className}>
                <Label active={!this.props.flipped}>Окна</Label>
                <ToggleBody>
                    <ToggleWrapper>
                        <Handle flipped={this.props.flipped}/>
                    </ToggleWrapper>
                </ToggleBody>
                <Label active={this.props.flipped}>Двери</Label>
            </div>
        );
    };
}


export default styled(Toggle)`
  display: flex;
  height: 40px;
  align-items: center;
  cursor: pointer;
`;